import {
    USER_PROFILE_LOAD_CONTENT,
    USER_PROFILE_CONTENT_LOADED,
    USER_PROFILE_SHOW_LOADER,
    USER_PROFILE_HIDE_LOADER,
} from './constants'

export function loadContent(id) {
    return {
        type: USER_PROFILE_LOAD_CONTENT,
        data: {
            id,
        },
    }
}

export function contentLoaded(id, contentData) {
    return {
        type: USER_PROFILE_CONTENT_LOADED,
        data: {
            id,
            contentData, // should be immutable
        },
    }
}

export function showLoader(id) {
    return {
        type: USER_PROFILE_SHOW_LOADER,
        data: {
            id,
        },
    }
}

export function hideLoader(id) {
    return {
        type: USER_PROFILE_HIDE_LOADER,
        data: {
            id,
        },
    }
}
